import all from 'marketing-website/media/images/pages/pop/devices/all@2x.png';
import appleTV from 'marketing-website/media/images/pages/pop/devices/apple-tv@2x.png';
import iPad from 'marketing-website/media/images/pages/pop/devices/ipad@2x.png';
import iPhone from 'marketing-website/media/images/pages/pop/devices/iphone@2x.png';
import pixel from 'marketing-website/media/images/pages/pop/devices/pixel@2x.png';
import stars from 'marketing-website/media/images/pages/pop/devices/stars@2x.png';

const assets = {
  all: {
    alt: 'iPad, iPhone, Apple TV and Pixel devices',
    maxWidth: 540,
    src: all,
    hasShadow: false,
  },
  appleTV: {
    alt: 'Apple TV device',
    maxWidth: 159,
    src: appleTV,
    hasShadow: false,
  },
  iPad: {
    alt: 'iPad device',
    maxWidth: 316,
    src: iPad,
    hasShadow: false,
  },
  iPhone: {
    alt: 'iPhone device',
    maxWidth: 146,
    src: iPhone,
    hasShadow: false,
  },
  pixel: {
    alt: 'Android Pixel device',
    maxWidth: 153,
    src: pixel,
    hasShadow: false,
  },
  stars: {
    alt: 'Star, circle and square',
    maxWidth: 89,
    src: stars,
    hasShadow: false,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/pop/devices.js